import { render, staticRenderFns } from "./trashitems.vue?vue&type=template&id=28439749"
import script from "./trashitems.vue?vue&type=script&lang=js"
export * from "./trashitems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports